import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next'

import React, { useState } from 'react';
import { Container, TextField, MenuItem, Typography, Paper } from '@mui/material';

const CurrencyConverter = ({
    currencies, initialAmount = 1, initialFromCurrency = 'USD', initialToCurrency = 'EUR',
    onAmountChange, onFromCurrencyChange, onToCurrencyChange, getExchangeRate,
}) => {

    const { t } = useTranslation();

    const [amount, setAmount] = useState(initialAmount);
    const [fromCurrency, setFromCurrency] = useState(initialFromCurrency);
    const [toCurrency, setToCurrency] = useState(initialToCurrency);
    const [convertedAmount, setConvertedAmount] = useState(null);

    const handleConvert = async () => {
        if (fromCurrency === toCurrency) {
            setConvertedAmount(amount);
        } else {
            const rate = await getExchangeRate(fromCurrency, toCurrency);
            setConvertedAmount((amount * rate).toFixed(2));
        }
    };

    const updateAmount = (amount) => {
        if (onAmountChange) onAmountChange(amount);
        setAmount(amount);
    };

    const updateFromCurrency = (fromCurrency) => {
        if (onFromCurrencyChange) onFromCurrencyChange(fromCurrency);
        setFromCurrency(fromCurrency);
    };

    const updateToCurrency = (toCurrency) => {
        if (onToCurrencyChange) onToCurrencyChange(toCurrency);
        setToCurrency(toCurrency);
    };

    return (
        <Container maxWidth="sm">
            <Paper sx={{ p: 4, textAlign: "center" }}>
                <Typography variant="h5" gutterBottom>
                    {t('currencyConverter.componentTitle')}
                </Typography>
                <TextField
                    id="amount-input"
                    label={t('currencyConverter.labelAmount')}
                    type="number"
                    value={amount}
                    onChange={(e) => updateAmount(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                />
                <TextField
                    id="from-currency"
                    select
                    label={t('currencyConverter.labelFrom')}
                    value={fromCurrency}
                    onChange={(e) => updateFromCurrency(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                >
                {currencies.map((currency) => (
                    <MenuItem key={currency.code} value={currency.code}>
                        {`${currency.code} - ${currency.name}`}
                    </MenuItem>
                ))}
                </TextField>
                <TextField
                    id="to-currency"
                    select
                    label={t('currencyConverter.labelTo')}
                    value={toCurrency}
                    onChange={(e) => updateToCurrency(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                >
                {currencies.map((currency) => (
                    <MenuItem key={currency.code} value={currency.code}>
                        {`${currency.code} - ${currency.name}`}
                    </MenuItem>
                ))}
                </TextField>
                <Typography variant="h6" gutterBottom>
                    {t('currencyConverter.labelConvertedAmount')}: {convertedAmount !== null ? convertedAmount : "-"} {toCurrency}
                </Typography>
                <button
                    type="button"
                    className='pill'
                    onClick={handleConvert}
                    style={{ marginTop: "10px", padding: "10px 20px", cursor: "pointer", fontSize: 16 }}
                >
                    {t('currencyConverter.buttonConvert')}
                </button>
            </Paper>
        </Container>
    );
};

CurrencyConverter.propTypes = {
    currencies: PropTypes.array.isRequired,
    initialAmount: PropTypes.number,
    initialFromCurrency: PropTypes.string,
    initialToCurrency: PropTypes.string,
    onAmountChange: PropTypes.func,
    onFromCurrencyChange: PropTypes.func,
    onToCurrencyChange: PropTypes.func,
    getExchangeRate: PropTypes.func.isRequired,
};

export default CurrencyConverter;
